// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plandecarreraAnalytics-main .hierarchical-level span {
  font-weight: bold;
  font-size: 38px;
  color: #7b7b7b;
}
.plandecarreraAnalytics-main .hierarchical-level .content-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin: 3px 0;
}
.plandecarreraAnalytics-main .hierarchical-level .content-item .box {
  height: 16px;
  border: 2px solid #5f52c4;
  margin-right: 3px;
  border-radius: 50rem;
}
.plandecarreraAnalytics-main .hierarchical-level .content-item .box.actualLevel {
  background: #5f52c4;
  cursor: default;
}
.plandecarreraAnalytics-main .hierarchical-level .content-item .box.nextLevel {
  background: #40c3fe;
  border: solid #40c3fe;
}
.plandecarreraAnalytics-main .text-right {
  text-align: right;
  font-size: 18px;
  color: #7b7b7b;
}
.plandecarreraAnalytics-main .margin-card {
  padding-top: 20px;
  margin-bottom: 20px;
}
.plandecarreraAnalytics-main .margin-left {
  text-align: left;
  margin-left: 15px;
}
.plandecarreraAnalytics-main .content-nivel {
  display: flex;
  align-items: center;
}
.plandecarreraAnalytics-main .title-nivel {
  font-weight: bold;
  font-size: 26px;
  color: #7b7b7b;
}
.plandecarreraAnalytics-main .body-nivel {
  padding: 30px 50px;
}
.plandecarreraAnalytics-main .informative-body-text {
  padding: 18px 0;
  color: #5f52c4;
}
.plandecarreraAnalytics-main .possible-areas {
  padding: 8px 0;
  color: #40c3fe;
  font-weight: bold;
}
.plandecarreraAnalytics-main .actual-nivel-text {
  font-size: 18px;
  color: #5f52c4;
}
.plandecarreraAnalytics-main .next-nivel-text {
  font-size: 18px;
  color: #40c3fe;
}
.plandecarreraAnalytics-main .align-nivel-title {
  margin-left: 282px;
}
.plandecarreraAnalytics-main .card-career {
  background: white;
}

.content-plan-carrera .title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 30px;
}
.content-plan-carrera .title .icon {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  padding: 8px;
  margin: 0 10px;
}
.content-plan-carrera .title .icon svg {
  fill: white;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Views/Analytics/planCarrera.sass"],"names":[],"mappings":"AAEQ;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AADZ;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AADZ;AAGY;EACI,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;AADhB;AAGgB;EACI,mBAAA;EACA,eAAA;AADpB;AAEgB;EACI,mBAAA;EACA,qBAAA;AAApB;AAEI;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AAAR;AAGI;EACI,iBAAA;EACA,mBAAA;AADR;AAGI;EACI,gBAAA;EACA,iBAAA;AADR;AAGI;EACI,aAAA;EACA,mBAAA;AADR;AAGI;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AADR;AAGI;EACI,kBAAA;AADR;AAGI;EACI,eAAA;EACA,cAAA;AADR;AAGI;EACI,cAAA;EACA,cAAA;EACA,iBAAA;AADR;AAGI;EACI,eAAA;EACA,cAAA;AADR;AAGI;EACI,eAAA;EACA,cAAA;AADR;AAGI;EACI,kBAAA;AADR;AAGI;EACI,iBAAA;AADR;;AAMI;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;AAHR;AAKQ;EACI,4DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;AAHZ;AAKY;EACI,WAAA;EACA,WAAA;AAHhB","sourcesContent":[".plandecarreraAnalytics-main\n    .hierarchical-level\n        span\n            font-weight: bold\n            font-size: 38px\n            color: #7b7b7b\n\n        .content-item\n            display: flex\n            align-items: center\n            font-size: 16px\n            margin: 3px 0\n            \n            .box\n                height: 16px\n                border: 2px solid #5f52c4\n                margin-right: 3px\n                border-radius: 50rem\n\n                &.actualLevel\n                    background: #5f52c4\n                    cursor: default\n                &.nextLevel\n                    background: #40c3fe\n                    border: solid #40c3fe\n\n    .text-right\n        text-align: right\n        font-size: 18px\n        color: #7b7b7b\n\n\n    .margin-card\n        padding-top: 20px\n        margin-bottom: 20px  \n\n    .margin-left\n        text-align: left\n        margin-left: 15px\n\n    .content-nivel\n        display: flex\n        align-items: center\n        \n    .title-nivel\n        font-weight: bold\n        font-size: 26px\n        color: #7b7b7b\n\n    .body-nivel\n        padding: 30px 50px\n\n    .informative-body-text\n        padding: 18px 0\n        color: #5f52c4\n\n    .possible-areas\n        padding: 8px 0\n        color: #40c3fe\n        font-weight: bold\n\n    .actual-nivel-text\n        font-size: 18px\n        color: #5f52c4\n\n    .next-nivel-text\n        font-size: 18px\n        color: #40c3fe\n\n    .align-nivel-title\n        margin-left: 282px\n\n    .card-career\n        background: white\n\n\n.content-plan-carrera\n\n    & .title\n        display: flex\n        align-items: center\n        justify-content: flex-start\n        margin-left: 30px\n\n        & .icon\n            background: linear-gradient(45deg,#40c2ff 0%, #32d8d8 100%)\n            width: 50px\n            height: 50px\n            border-radius: 50rem\n            padding: 8px\n            margin: 0 10px\n\n            & svg\n                fill: white\n                width: 100%"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
